var map = {
	"./AashiqueAhmedIqbal.png": 596,
	"./BusinessintheTimeofContagion.jpeg": 597,
	"./KarunaWielenga.png": 598,
	"./LakshmiSubramanian.png": 599,
	"./LouizaRodrigues.png": 600,
	"./MadMenofBombay.png": 601,
	"./MilanBalaban.png": 602,
	"./PowerPrivilegePosture.jpeg": 603,
	"./SaritaSundar.png": 604,
	"./Speaker1.png": 605,
	"./SusiePak.png": 606,
	"./TheGlobalBlueJeansTransformation.jpg": 607,
	"./TimberTradeTrajectory.jpeg": 608,
	"./TraceyPanek.png": 609,
	"./TypewriterTipTip.png": 610,
	"./WilliamMazzarella.png": 611,
	"./details-banner/BusinessInTheTimeOfContagion.png": 612,
	"./details-banner/MadMenOfBombay.png": 613,
	"./details-banner/PowerPrivilegeposture.png": 614,
	"./details-banner/TheGlobalBlueJeans.png": 615,
	"./details-banner/TimberTradeTrajectory.png": 616,
	"./details-banner/TypewriterTipTip.png": 617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;